// src/pages/HomePage.js
import React, { useEffect } from 'react';
import GirisSection from '../sections/GirisSection'; // Assuming you create this file
import HakkimizdaSection from '../sections/HakkimizdaSection';
import OzelliklerSection from '../sections/OzelliklerSection';
import ProjelerSection from '../sections/ProjelerSection';
import YayindanSection from '../sections/YayindanSection';
import IletisimSection from '../sections/IletisimSection';
import Footer from '../components/Footer';

function HomePage() {
  // Optional: Handle initial scroll if a hash is present in the URL
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const id = hash.substring(1); // Remove the '#'
      const element = document.getElementById(id);
      if (element) {
        window.scrollTo({
          top: element.offsetTop - 50, // Adjust for fixed header
          behavior: 'smooth'
        });
      }
    }
  }, []);

  return (
    <div>
      {/* Each component below represents a section of your single page */}
      <section id="giris">
        <GirisSection />
      </section>
      <section id="hakkimizda">
        <HakkimizdaSection />
      </section>
      <section id="ozellikler">
        <OzelliklerSection />
      </section>
      <section id="ozellikler">
        <ProjelerSection />
      </section>
      <section id="projeler">
        <YayindanSection />
      </section>
      <section id="yayindan">
        <IletisimSection />
      </section>
       <section id="iletisim">
        <Footer />
      </section>
    </div>
  );
}

export default HomePage;